var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLikeWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.69v6.81h10.662L15 6.452l-7.068-.371L8 1.5H5.833L4.192 6.08 2.5 7.69zM13.667 11.5H12.5m1.5-2h-1M.5 15V7.5",
    stroke: "#fff"
  })));
}
export default SvgIconLikeWhite;